import { RouteObject } from "react-router-dom";
import Login from "./login/Login";
import { SessionTimeout } from "./sessionTimeout/SessionTimeout";
import MicrosoftCallback from "./microsoft/callback/MicrosoftCallback";
import MicrosoftLogout from "./microsoft/logout/MicrosoftLogout";

const LOGIN = "login";
const SESSIONTIMEOUT = "session-timeout";
const MICROSOFTCALLBACK = "microsoft/callback";
const MICROSOFTLOGOUT = "microsoft/logout";

export const routerAuth: RouteObject[] = [
  { path: "", element: <Login /> },
  { path: LOGIN, element: <Login /> },
  { path: SESSIONTIMEOUT, element: <SessionTimeout /> },
  { path: MICROSOFTCALLBACK, element: <MicrosoftCallback /> },
  { path: MICROSOFTLOGOUT, element: <MicrosoftLogout /> },
];
